<template>
  <v-card
    class="ma-4"
    color="white"
  >
    <v-card-title
      class="blue-grey white--text"
    >Aktivasi Login
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <div v-if="aktif">
            <p class="title">Akun Anda sudah aktif</p>
            <p><span class="subtitle-2">E-Mail</span> {{ email }}</p>
            <p><span class="subtitle-2">User ID</span> {{ userId }}</p>
          </div>
          <div v-else>
            <p class="title">Aktivasi Gagal !</p>
            <p>{{ message }}</p>
            <!-- <div v-if="expired">
              <p>Silahkan klik tombol berikut untuk memperbaharui link aktivasi Anda</p>
              <div><v-btn color="orange" dark>Perbaharui link aktivasi</v-btn></div>
            </div> -->
          </div>
        </v-col>
      </v-row>        
    </v-card-text>
    <v-divider class="mt-2" />
    <v-card-actions class="">
      <v-btn color="blue" dark click="" to="/">Kembali ke Home</v-btn>
    </v-card-actions>
  </v-card>  
</template>

<script>
import axios from 'axios'
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  data: function() {
    return {
      aktif: false,
      expired: false,
      userId: '',
      email: '',
      message: '',
      kodeUrl: '',
      jenisError: ''
    }
  },
  created: async function() {
    this.kodeUrl = this.$route.params.kodeUrl
    await axios.post(apiUrl+'/member/activity', { kodeUrl: this.kodeUrl })
    .then((response) => {
      this.aktif = true       
      this.email = response.data.data.email
      this.userId = response.data.data.userId 
    })
    .catch((error) => {
      const errMsg = JSON.parse(error.response.data.message)
      this. jenisError = errMsg.jenis
      this.aktif = false
      this.message = errMsg.message
      this.expired = this.jenisError === 'EXP' ? true : false
    })
  }

}
</script>

<style>

</style>